/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
import React from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon/types';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { token } from '@atlaskit/tokens';

export const AtlassianIntelligenceLogoDark = (props: NewCoreIconProps): React.JSX.Element => (
	<AtlassianIntelligenceIcon color={token('color.icon')} {...props} />
);
